import { Component, input, computed } from '@angular/core';

import { AvailableLanguageCodesEnum } from '@ui/shared/model';

import { ImageComponent } from '../image.component';
import { ImageBorderRadiusEnum, ImageSrcSet } from '../image.model';

@Component({
  selector: 'app-locale-flag',
  templateUrl: './locale-flag.component.html',
  styleUrls: ['./locale-flag.component.scss'],
  imports: [ImageComponent]
})
export class LocaleFlagComponent {
  readonly languageCode = input(AvailableLanguageCodesEnum.DE);

  public ImageBorderRadiusEnum = ImageBorderRadiusEnum;

  readonly flagImagePath = computed(() =>
    this.getFlagImagePath(this.languageCode())
  );
  readonly flagImageSources = computed(() => {
    const srcSet: ImageSrcSet = {};
    for (let i = 0; i < 3; i++) {
      const pixelDensity = i + 1;
      srcSet[`x${pixelDensity}`] = `${this.getFlagImagePath(
        `${this.languageCode()}${i !== 0 ? `@${pixelDensity}x` : ''}`
      )}`;
    }
    return [{ srcSet }];
  });

  private getFlagImagePath(fileName: string) {
    return `/assets/images/flags/${fileName}.png`;
  }
}
